// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsappButton_root__Vjudv","iconWhatsappLink":"WhatsappButton_iconWhatsappLink__1-jzK","invertIconWhatsappButton":"WhatsappButton_invertIconWhatsappButton__gYZj0"};